import { lighten, OPA_30 } from '../themeUtils.js';

export function led(ctx) {
    return {
        styles: {
            main: {
                bg_color:     ctx.primary,
                bg_opa:       255,
                border_width: 2,
                border_color: lighten(ctx.primary, OPA_30),
                radius:       999,
                // shadow_width(15)/shadow_spread(5) already match firmware via the schema
                // default (lv_theme_material.c:407,409, LV_DPX(15)/LV_DPX(5)) — only
                // shadow_color needs a theme-level override, since firmware's real value is
                // theme.color_primary (lv_theme_material.c:408), not the schema's placeholder
                // '#00aaff' literal (schema can't reference a runtime-configurable hue).
                shadow_color: ctx.primary,
            },
        },
    };
}
